import { Component, EventEmitter, Input } from '@angular/core';
import { LiveAssetStatus } from '@app/shared/models/live-status.model';
import { Observable, of } from 'rxjs';
import { catchError, startWith, tap } from 'rxjs/operators';
import { Image } from '@app/shared/models/image.model';
import { AssetImagesStoreService } from '@core/stores/asset-images-store.service';
import { ENDPOINTS } from '@core/constants/endpoints';
import { WindowRefService } from '@core/services/helpers/window-ref.service';
import { NotificationsService } from '@core/services/notifications.service';
import { NotificationType } from '@core/constants/notifications';
import { AssetDrillDownHelperService } from '@app/shared/helpers/asset-drill-down-helper.service';
import { ExploreDrillDownTimeRange } from '@app/shared/models/explore-drill-down.model';
import moment from 'moment';

@Component({
    selector: 'app-asset-drill-down',
    templateUrl: './asset-drill-down.component.html',
    styleUrls: ['./asset-drill-down.component.scss'],
    standalone: false,
})
export class AssetDrillDownComponent {
    @Input() width: number;

    assetStatus$: Observable<LiveAssetStatus>;
    image$: Observable<Image>;
    error: EventEmitter<void> = new EventEmitter<void>();

    private window: Window;

    constructor(
        private assetImagesStore: AssetImagesStoreService,
        private windowRefService: WindowRefService,
        private notificationsService: NotificationsService,
        private assetDrillDownHelperService: AssetDrillDownHelperService
    ) {
        this.window = this.windowRefService.window;
        this.assetStatus$ = this.assetDrillDownHelperService.data$.pipe(
            startWith(undefined),
            tap(() => {
                this.image$ = this.assetImagesStore.getImage(
                    this.assetDrillDownHelperService.overlayConfig.assetId
                );
            }),
            catchError(() => {
                this.error.emit();
                this.notificationsService.showNotification(
                    NotificationType.Error,
                    'There was an error when getting the asset information. Please try again later.'
                );
                return of(undefined);
            })
        );
    }

    onRedirectToAssetDetail(id: number) {
        this.window.open(
            `${this.window.location.origin}${ENDPOINTS.urls.assets.detail}#?id=${id}&alert`,
            '_blank'
        );
    }

    onOpenAssetEventsMonitoring(id: number) {
        this.window.open(
            `${this.window.location.origin}/#/asset/${id}/events-monitor`,
            '_blank',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600'
        );
    }

    onRedirectToAssetExplore(status: LiveAssetStatus) {
        const timeRange: ExploreDrillDownTimeRange = {
            from: moment().startOf('day').valueOf(),
            to: moment().endOf('day').valueOf(),
        };

        this.assetDrillDownHelperService.closeDrillDown();
        this.assetDrillDownHelperService.navigateToAssetExplore(
            status.asset.id,
            timeRange,
            status.exploreGroups
        );
    }
}
